<template>
    <vue-select
        :value="value"
        @input="handleInput"
        v-if="options"
        v-bind="$attrs"
        v-on="$listeners"
        :options="filtered_options"
        :getOptionLabel="(opt) => opt.first_name + ' ' + opt.last_name"
    >
        <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
                Hittade inga resultat på <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Sök på adress</em>
        </template>
    </vue-select>
</template>

<script>
import VueSelect from '@components/Wrappers/VueSelect';
import UserRepository from '@services/repositories/UserRepository';

export default {
    name: 'UserFilter',
    components: {
        VueSelect,
    },
    props: {
        value: null,
        filter: {
            type: Function,
            default(options) {
                return options;
            },
        },
    },
    data() {
        return {
            options: null,
        };
    },
    async created() {
        this.options = await this.getOptions();
    },
    methods: {
        handleInput(value) {
            this.$emit('input', value);
        },
        async getOptions() {
            let options = [];

            const client = new UserRepository();
            const users = await client.getAll();
            if (users) {
                options = users.filter((user) => !user.deleted_at && user.id > 0);
            }

            return options;
        },
    },
    computed: {
        filtered_options() {
            return this.filter(this.options);
        },
    },
};
</script>
